(() => {
  const SELECTOR = '[data-lpcollection]';

  function initSection(section) {
    if (!section || section.dataset.lpcollectionReady === 'true') return;
    section.dataset.lpcollectionReady = 'true';

    const compareButton = section.querySelector('[data-lpcollection-compare]');
    const comparison = section.querySelector('.lpcollection__comparison');
    const cards = Array.from(section.querySelectorAll('[data-product-card]'));

    if (!compareButton || !comparison) return;

    compareButton.addEventListener('click', () => {
      comparison.scrollIntoView({ behavior: 'smooth', block: 'center' });

      cards.forEach((card) => {
        card.classList.remove('is-highlighted');
        void card.offsetWidth;
        card.classList.add('is-highlighted');
      });

      window.setTimeout(() => {
        cards.forEach((card) => card.classList.remove('is-highlighted'));
      }, 1100);
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();